import styled from 'styled-components'

export const Empty = styled.div`
	background-color: ${({ theme }) => theme.color.input.menuBackground};
	color: ${({ theme }) => theme.color.input.menuEmpty};
	text-align: center;
	padding: 12px;
	border-radius: 4px;
`
